import { render, staticRenderFns } from "./user-cards-register.vue?vue&type=template&id=786bfaca&"
import script from "./user-cards-register.vue?vue&type=script&lang=js&"
export * from "./user-cards-register.vue?vue&type=script&lang=js&"
import style0 from "./user-cards-register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports